import { PRODUCT_TYPE } from "@erp/shared/types/product.types";
export const mockBOM = [
    {
        id: 3,
        type: PRODUCT_TYPE.완제품,
        productCode: "FG-CTRL-0010",
        classificationId: 10,
        classification: "컨트롤러",
        manufacturerId: 1,
        manufacturer: "PION",
        model: "CTRL-10",
        name: "산업용 컨트롤러 10",
        spec: "IP54",
        directlyWritten: 0,
        quantityUnit: "EA",
        images: [],
        quantity: 1,
        children: [
            {
                id: 2,
                type: PRODUCT_TYPE.반제품,
                productCode: "SEMI-PCB-0007",
                classificationId: 20,
                classification: "PCB",
                manufacturerId: 2,
                manufacturer: "PION Electronics",
                model: "PCB-V2",
                name: "컨트롤러 PCB V2",
                spec: "4-Layers",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 1,
                children: [
                    {
                        id: 1001,
                        type: PRODUCT_TYPE.원부자재,
                        productCode: "RM-RES-100K",
                        classificationId: 70,
                        classification: "저항",
                        manufacturerId: 3,
                        manufacturer: "Yageo",
                        model: "RC0805-100K",
                        name: "칩 저항 100kΩ",
                        spec: "0805, 1%, 0.125W",
                        directlyWritten: 0,
                        quantityUnit: "EA",
                        images: [],
                        quantity: 10,
                        children: [],
                    },
                    {
                        id: 1002,
                        type: PRODUCT_TYPE.원부자재,
                        productCode: "RM-CAP-10U",
                        classificationId: 4,
                        classification: "커패시터",
                        manufacturerId: 5,
                        manufacturer: "Samsung Electro-Mechanics",
                        model: "CL21A106KAYNNNE",
                        name: "MLCC 10uF",
                        spec: "0805, 25V, X5R",
                        directlyWritten: 0,
                        quantityUnit: "EA",
                        images: [],
                        quantity: 6,
                        children: [],
                    },
                    {
                        id: 1003,
                        type: PRODUCT_TYPE.원부자재,
                        productCode: "RM-IC-MCU32",
                        classificationId: 5,
                        classification: "IC",
                        manufacturerId: 6,
                        manufacturer: "ST",
                        model: "STM32F103C8T6",
                        name: "MCU 32-bit",
                        spec: "LQFP48",
                        directlyWritten: 0,
                        quantityUnit: "EA",
                        images: [],
                        quantity: 1,
                        children: [],
                    },
                ],
            },
            {
                id: 4,
                type: PRODUCT_TYPE.반제품,
                productCode: "SEMI-HSG-0012",
                classificationId: 30,
                classification: "하우징",
                manufacturerId: 3,
                manufacturer: "PION Plastics",
                model: "HSG-12",
                name: "컨트롤러 하우징",
                spec: "ABS, Black",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 1,
                children: [
                    {
                        id: 1,
                        type: PRODUCT_TYPE.원부자재,
                        productCode: "RM-AL-0001",
                        classificationId: 40,
                        classification: "알루미늄",
                        manufacturerId: 4,
                        manufacturer: "PION Metals",
                        model: "AL-6061",
                        name: "알루미늄 6061 바",
                        spec: "Ø20 x 1000",
                        directlyWritten: 0,
                        quantityUnit: "EA",
                        images: [],
                        quantity: 2,
                        children: [],
                    },
                ],
            },
        ],
    },
    {
        id: 2,
        type: PRODUCT_TYPE.반제품,
        productCode: "SEMI-PCB-0007",
        classificationId: 20,
        classification: "PCB",
        manufacturerId: 2,
        manufacturer: "PION Electronics",
        model: "PCB-V2",
        name: "컨트롤러 PCB V2",
        spec: "4-Layers",
        directlyWritten: 0,
        quantityUnit: "EA",
        images: [],
        quantity: 1,
        children: [
            {
                id: 1001,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-RES-100K",
                classificationId: 70,
                classification: "저항",
                manufacturerId: 3,
                manufacturer: "Yageo",
                model: "RC0805-100K",
                name: "칩 저항 100kΩ",
                spec: "0805, 1%, 0.125W",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 10,
                children: [],
            },
            {
                id: 1002,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-CAP-10U",
                classificationId: 4,
                classification: "커패시터",
                manufacturerId: 5,
                manufacturer: "Samsung Electro-Mechanics",
                model: "CL21A106KAYNNNE",
                name: "MLCC 10uF",
                spec: "0805, 25V, X5R",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 6,
                children: [],
            },
            {
                id: 1003,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-IC-MCU32",
                classificationId: 5,
                classification: "IC",
                manufacturerId: 6,
                manufacturer: "ST",
                model: "STM32F103C8T6",
                name: "MCU 32-bit",
                spec: "LQFP48",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 1,
                children: [],
            },
        ],
    },
    {
        id: 8,
        type: PRODUCT_TYPE.완제품,
        productCode: "FG-SENSOR-0011",
        classificationId: 50,
        classification: "센서",
        manufacturerId: 7,
        manufacturer: "Sensor Pro",
        model: "SENS-TEMP",
        name: "온도 센서",
        spec: "-40°C ~ +125°C",
        directlyWritten: 0,
        quantityUnit: "EA",
        images: [],
        quantity: 1,
        children: [
            {
                id: 1004,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-THERM-100K",
                classificationId: 60,
                classification: "서미스터",
                manufacturerId: 8,
                manufacturer: "Murata",
                model: "NCP18XH103F03RB",
                name: "NTC 서미스터 10kΩ",
                spec: "0603, B25/50=3435K",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 1,
                children: [],
            },
            {
                id: 1005,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-RES-4K7",
                classificationId: 70,
                classification: "저항",
                manufacturerId: 3,
                manufacturer: "Yageo",
                model: "RC0603-4K7",
                name: "칩 저항 4.7kΩ",
                spec: "0603, 1%, 0.1W",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 2,
                children: [],
            },
            {
                id: 6,
                type: PRODUCT_TYPE.반제품,
                productCode: "SEMI-CASE-0008",
                classificationId: 80,
                classification: "케이스",
                manufacturerId: 9,
                manufacturer: "Case Works",
                model: "CASE-AL",
                name: "알루미늄 케이스",
                spec: "200 x 150 x 50",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 1,
                children: [
                    {
                        id: 1,
                        type: PRODUCT_TYPE.원부자재,
                        productCode: "RM-AL-0001",
                        classificationId: 40,
                        classification: "알루미늄",
                        manufacturerId: 4,
                        manufacturer: "PION Metals",
                        model: "AL-6061",
                        name: "알루미늄 6061 바",
                        spec: "Ø20 x 1000",
                        directlyWritten: 0,
                        quantityUnit: "EA",
                        images: [],
                        quantity: 0.5,
                        children: [],
                    },
                ],
            },
        ],
    },
    {
        id: 9,
        type: PRODUCT_TYPE.완제품,
        productCode: "FG-MOTOR-0012",
        classificationId: 208,
        classification: "모터",
        manufacturerId: 10,
        manufacturer: "Motor Inc",
        model: "MOT-STEP",
        name: "스테핑 모터",
        spec: "1.8° 2A",
        directlyWritten: 0,
        quantityUnit: "EA",
        images: [],
        quantity: 1,
        children: [
            {
                id: 1006,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-MAG-N35",
                classificationId: 90,
                classification: "자석",
                manufacturerId: 11,
                manufacturer: "Magnet Pro",
                model: "N35-NdFeB",
                name: "네오디뮴 자석 N35",
                spec: "Ø10 x 5",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 2,
                children: [],
            },
            {
                id: 1007,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-COIL-0.5",
                classificationId: 100,
                classification: "코일",
                manufacturerId: 12,
                manufacturer: "Coil Tech",
                model: "COIL-0.5MM",
                name: "구리 코일 0.5mm",
                spec: "Ø0.5 x 100m",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 50,
                children: [
                    {
                        id: 5,
                        type: PRODUCT_TYPE.원부자재,
                        productCode: "RM-CU-0003",
                        classificationId: 200,
                        classification: "구리",
                        manufacturerId: 13,
                        manufacturer: "Copper Ltd",
                        model: "CU-101",
                        name: "구리 와이어",
                        spec: "Ø2.0 x 100m",
                        directlyWritten: 0,
                        quantityUnit: "EA",
                        images: [],
                        quantity: 0.5,
                        children: [],
                    },
                ],
            },
            {
                id: 1008,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-BEAR-608",
                classificationId: 110,
                classification: "베어링",
                manufacturerId: 14,
                manufacturer: "Bearing Corp",
                model: "608ZZ",
                name: "볼 베어링 608ZZ",
                spec: "8x22x7",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 2,
                children: [],
            },
        ],
    },
    {
        id: 12,
        type: PRODUCT_TYPE.완제품,
        productCode: "FG-DISPLAY-0013",
        classificationId: 120,
        classification: "디스플레이",
        manufacturerId: 15,
        manufacturer: "Display Tech",
        model: "LCD-7",
        name: "7인치 LCD 디스플레이",
        spec: "800x480 RGB",
        directlyWritten: 0,
        quantityUnit: "EA",
        images: [],
        quantity: 1,
        children: [
            {
                id: 1009,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-LCD-PANEL",
                classificationId: 130,
                classification: "LCD 패널",
                manufacturerId: 16,
                manufacturer: "LCD Corp",
                model: "LCD-7INCH",
                name: "7인치 LCD 패널",
                spec: "800x480, RGB",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 1,
                children: [],
            },
            {
                id: 1010,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-BACKLIGHT-LED",
                classificationId: 140,
                classification: "LED",
                manufacturerId: 17,
                manufacturer: "LED Pro",
                model: "LED-WHITE-3528",
                name: "백라이트 LED",
                spec: "3528, White, 3.2V",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 12,
                children: [],
            },
            {
                id: 1011,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-FPC-CABLE",
                classificationId: 150,
                classification: "FPC 케이블",
                manufacturerId: 18,
                manufacturer: "Flex Cable",
                model: "FPC-40PIN",
                name: "FPC 케이블 40핀",
                spec: "40pin, 0.5mm pitch",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 1,
                children: [],
            },
            {
                id: 6,
                type: PRODUCT_TYPE.반제품,
                productCode: "SEMI-CASE-0008",
                classificationId: 80,
                classification: "케이스",
                manufacturerId: 9,
                manufacturer: "Case Works",
                model: "CASE-AL",
                name: "알루미늄 케이스",
                spec: "200 x 150 x 50",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 1,
                children: [
                    {
                        id: 1,
                        type: PRODUCT_TYPE.원부자재,
                        productCode: "RM-AL-0001",
                        classificationId: 40,
                        classification: "알루미늄",
                        manufacturerId: 4,
                        manufacturer: "PION Metals",
                        model: "AL-6061",
                        name: "알루미늄 6061 바",
                        spec: "Ø20 x 1000",
                        directlyWritten: 0,
                        quantityUnit: "EA",
                        images: [],
                        quantity: 1,
                        children: [],
                    },
                ],
            },
        ],
    },
    {
        id: 6,
        type: PRODUCT_TYPE.반제품,
        productCode: "SEMI-CASE-0008",
        classificationId: 80,
        classification: "케이스",
        manufacturerId: 9,
        manufacturer: "Case Works",
        model: "CASE-AL",
        name: "알루미늄 케이스",
        spec: "200 x 150 x 50",
        directlyWritten: 0,
        quantityUnit: "EA",
        images: [],
        quantity: 1,
        children: [
            {
                id: 1,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-AL-0001",
                classificationId: 40,
                classification: "알루미늄",
                manufacturerId: 4,
                manufacturer: "PION Metals",
                model: "AL-6061",
                name: "알루미늄 6061 바",
                spec: "Ø20 x 1000",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 2,
                children: [],
            },
            {
                id: 4,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-ST-0002",
                classificationId: 160,
                classification: "강철",
                manufacturerId: 19,
                manufacturer: "Steel Corp",
                model: "ST-304",
                name: "스테인리스강 304 플레이트",
                spec: "1000 x 2000 x 3T",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 0.1,
                children: [],
            },
        ],
    },
    {
        id: 7,
        type: PRODUCT_TYPE.반제품,
        productCode: "SEMI-CABLE-0009",
        classificationId: 170,
        classification: "케이블",
        manufacturerId: 20,
        manufacturer: "Cable Tech",
        model: "CBL-USB",
        name: "USB 케이블",
        spec: "USB-C 2m",
        directlyWritten: 0,
        quantityUnit: "EA",
        images: [],
        quantity: 1,
        children: [
            {
                id: 5,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-CU-0003",
                classificationId: 200,
                classification: "구리",
                manufacturerId: 13,
                manufacturer: "Copper Ltd",
                model: "CU-101",
                name: "구리 와이어",
                spec: "Ø2.0 x 100m",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 2,
                children: [],
            },
            {
                id: 1012,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-SHIELD-FOIL",
                classificationId: 180,
                classification: "차폐재",
                manufacturerId: 21,
                manufacturer: "Shield Tech",
                model: "AL-FOIL-25UM",
                name: "알루미늄 호일",
                spec: "25μm, 2m",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 2,
                children: [],
            },
            {
                id: 1013,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-CONN-USB-C",
                classificationId: 190,
                classification: "커넥터",
                manufacturerId: 22,
                manufacturer: "Connector Inc",
                model: "USB-C-24PIN",
                name: "USB-C 커넥터",
                spec: "24pin, SMT",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 2,
                children: [],
            },
        ],
    },
    {
        id: 11,
        type: PRODUCT_TYPE.반제품,
        productCode: "SEMI-SCREW-0010",
        classificationId: 210,
        classification: "나사",
        manufacturerId: 23,
        manufacturer: "Screw Master",
        model: "SCREW-M6",
        name: "M6 나사",
        spec: "M6 x 20",
        directlyWritten: 0,
        quantityUnit: "EA",
        images: [],
        quantity: 1,
        children: [
            {
                id: 4,
                type: PRODUCT_TYPE.원부자재,
                productCode: "RM-ST-0002",
                classificationId: 160,
                classification: "강철",
                manufacturerId: 19,
                manufacturer: "Steel Corp",
                model: "ST-304",
                name: "스테인리스강 304 플레이트",
                spec: "1000 x 2000 x 3T",
                directlyWritten: 0,
                quantityUnit: "EA",
                images: [],
                quantity: 0.01,
                children: [],
            },
        ],
    },
];
